import { FirebaseLemonator } from 'app/_angular/service/firebase-lemonator.service'
import { LlmTositeLukuOp, LlmTositeLukuPyynto, LlmTositeLukuPyyntoMap } from '../../../_jaettu-lemonator/model/llm-tosite-luku-testaus'

export function callLlmTositeLukuTestaus<K extends LlmTositeLukuOp>(firebase: FirebaseLemonator, op: K, payload: LlmTositeLukuPyyntoMap[K]['req']): Promise<LlmTositeLukuPyyntoMap[K]['resp']> {
  return firebase.functionsCall<LlmTositeLukuPyynto, LlmTositeLukuPyyntoMap[K]['resp']>('llmTositeLukuTestaus', { op, payload } as LlmTositeLukuPyynto)
}
